import type { IconProps } from '../types/IconProps.ts';
export const ArrowUpFromLine: IconProps = {
    name: 'ArrowUpFromLine',
    children: [
        `<path d="m6 9 5.65-5.85c.2-.2.5-.2.7 0L18 9M12 3.8V17M5 21h14" />`,
    ]
};